import React from 'react';
import Tooltip from "@material-ui/core/Tooltip";

type OutlinedIconProps = {
    onClick: Function,
    selected: boolean,
    tooltipText: string,
    outlinedIcon: JSX.Element,
    icon: JSX.Element
}

export const OutlinedIcon = ({ ...props }: OutlinedIconProps) => {
    return (
        !props.selected ?
            <Tooltip title={props.tooltipText} arrow placement="bottom" >
                <span className="wbm-outlined-icon" onClick={() => props.onClick()}>
                    {props.outlinedIcon}
                    {props.icon}
                </span>
            </Tooltip >
            :
            <Tooltip title={props.tooltipText} arrow placement="bottom" >
                <span className="wbm-outlined-icon-selected" onClick={() => props.onClick()}>
                    {props.icon}
                </span>
            </Tooltip >
    );
}
